<template>
    <div class="container-fluid">
        <div class="page-heading mb-4">
            <p class="page-eyebrow">PARTNER DIRECTORY</p>
            <h1 class="h3 mb-1 text-gray-800">Sponsors</h1>
            <p class="mb-0 text-muted">Search, review, and manage sponsor profiles in one place.</p>
        </div>

        <SponsorList></SponsorList>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import SponsorList from "@/components/master/SponsorList.vue";

export default defineComponent({
    name: "SponsorPage",
    components: {
        SponsorList
    }
})
</script>

<style scoped>
.page-heading {
    border-bottom: 1px solid #e2e6ea;
    padding-bottom: 1rem;
}

.page-eyebrow {
    color: #426cc6;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 0.35rem;
}
</style>
